import { render, staticRenderFns } from "./CompanyDocuments.vue?vue&type=template&id=755ebd64&scoped=true&"
import script from "./CompanyDocuments.vue?vue&type=script&lang=js&"
export * from "./CompanyDocuments.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDocuments.vue?vue&type=style&index=0&id=755ebd64&lang=scss&scoped=true&"
import style1 from "./CompanyDocuments.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755ebd64",
  null
  
)

export default component.exports